export const translations = {
    ar: {
        brand: "سراء تنت",
        tagline: "خيام الإمارات الفاخرة",
        nav: {
            home: "الرئيسية",
            products: "المنتجات",
            about: "من نحن",
            contact: "تواصل معنا",
            cart: "السلة",
            admin: "لوحة التحكم",
        },
        hero: {
            overline: "صناعة إماراتية أصيلة",
            title: "سرى للخيام تحكي قصص الصحراء",
            subtitle: "تصاميم فاخرة تجمع بين أصالة التراث وروح الحداثة، من قلب أبوظبي إلى منزلك.",
            cta_products: "اكتشف المجموعة",
            cta_contact: "تواصل معنا",
        },
        sections: {
            featured_overline: "مختارات من أعمالنا",
            featured_title: "أبرز منتجاتنا",
            featured_sub: "قطع مختارة بعناية، مصنوعة يدويًا بأعلى معايير الجودة.",
            story_overline: "قصتنا",
            story_title: "إرث بدوي بلمسة عصرية",
            story_body: "منذ سنوات ونحن في سراء تنت نحترف صناعة الخيام والمجالس الإماراتية الفاخرة. كل خيمة نصنعها تحمل في طياتها روح الصحراء وكرم أهل الإمارات.",
            cta_cta: "طلب عرض خاص",
        },
        product: {
            size: "القياس",
            qty: "الكمية",
            add_to_cart: "أضف إلى السلة",
            description: "الوصف",
            price: "السعر",
            currency: "د.إ",
            from: "ابتداءً من",
        },
        cart: {
            title: "سلة المشتريات",
            empty: "السلة فارغة",
            empty_sub: "تصفح مجموعتنا وأضف ما يناسبك",
            subtotal: "الإجمالي",
            checkout: "إتمام الطلب",
            remove: "إزالة",
            continue: "متابعة التسوق",
        },
        checkout: {
            title: "إتمام الطلب",
            customer_info: "معلومات العميل",
            name: "الاسم الكامل",
            email: "البريد الإلكتروني",
            phone: "رقم الهاتف",
            address: "العنوان",
            city: "المدينة",
            notes: "ملاحظات",
            payment_method: "طريقة الدفع",
            pay_card: "بطاقة / Apple Pay",
            pay_bank: "تحويل بنكي",
            place_order: "تأكيد الطلب",
            order_summary: "ملخص الطلب",
            total: "الإجمالي",
            bank_title: "تفاصيل التحويل البنكي",
            bank_instructions: "يرجى تحويل المبلغ إلى الحساب التالي ثم التواصل معنا عبر واتساب مع إرفاق إيصال التحويل ورقم الطلب.",
            order_placed: "تم استلام طلبك",
            order_number: "رقم الطلب",
        },
        success: {
            title: "تم الدفع بنجاح",
            subtitle: "شكرًا لثقتك. سنتواصل معك قريبًا لتأكيد التفاصيل.",
            back_home: "العودة للرئيسية",
        },
        footer: {
            rights: "جميع الحقوق محفوظة",
            contact_us: "تواصل معنا",
            quick_links: "روابط سريعة",
        },
        admin: {
            login: "دخول الأدمن",
            dashboard: "لوحة التحكم",
            orders: "الطلبات",
            products: "المنتجات",
            settings: "الإعدادات",
            logout: "خروج",
        },
    },
    en: {
        brand: "SRAA TENT",
        tagline: "UAE Luxury Camping",
        nav: {
            home: "Home",
            products: "Products",
            about: "About",
            contact: "Contact",
            cart: "Cart",
            admin: "Admin",
        },
        hero: {
            overline: "Authentic Emirati craft",
            title: "Tents that tell desert stories",
            subtitle: "Luxurious designs blending heritage and modernity, from the heart of Abu Dhabi to your home.",
            cta_products: "Explore Collection",
            cta_contact: "Get in Touch",
        },
        sections: {
            featured_overline: "Selected works",
            featured_title: "Featured Pieces",
            featured_sub: "Carefully curated items, hand-made to the highest standards.",
            story_overline: "Our Story",
            story_title: "Bedouin Heritage, Modern Touch",
            story_body: "For years SRAA TENT has been perfecting the craft of luxury Emirati tents and majlis. Every tent carries the soul of the desert and Emirati hospitality.",
            cta_cta: "Request a Custom Quote",
        },
        product: {
            size: "Size",
            qty: "Quantity",
            add_to_cart: "Add to Cart",
            description: "Description",
            price: "Price",
            currency: "AED",
            from: "From",
        },
        cart: {
            title: "Your Cart",
            empty: "Your cart is empty",
            empty_sub: "Browse our collection and add items",
            subtotal: "Subtotal",
            checkout: "Proceed to Checkout",
            remove: "Remove",
            continue: "Continue Shopping",
        },
        checkout: {
            title: "Checkout",
            customer_info: "Customer Information",
            name: "Full Name",
            email: "Email",
            phone: "Phone Number",
            address: "Address",
            city: "City",
            notes: "Notes",
            payment_method: "Payment Method",
            pay_card: "Card / Apple Pay",
            pay_bank: "Bank Transfer",
            place_order: "Place Order",
            order_summary: "Order Summary",
            total: "Total",
            bank_title: "Bank Transfer Details",
            bank_instructions: "Please transfer the amount to the following account and contact us via WhatsApp with the receipt and order number.",
            order_placed: "Your order has been received",
            order_number: "Order #",
        },
        success: {
            title: "Payment Successful",
            subtitle: "Thank you for your trust. We will contact you shortly to confirm details.",
            back_home: "Back to Home",
        },
        footer: {
            rights: "All rights reserved",
            contact_us: "Contact",
            quick_links: "Quick Links",
        },
        admin: {
            login: "Admin Login",
            dashboard: "Dashboard",
            orders: "Orders",
            products: "Products",
            settings: "Settings",
            logout: "Logout",
        },
    },
};

export const fmtPrice = (amount, lang = "ar") => {
    const n = new Intl.NumberFormat(lang === "ar" ? "ar-AE" : "en-AE", {
        maximumFractionDigits: 0,
    }).format(amount);
    const c = translations[lang].product.currency;
    return lang === "ar" ? `${n} ${c}` : `${c} ${n}`;
};
